// extracted by mini-css-extract-plugin
export default {"container":"EntityList_container__+5XWN","list":"EntityList_list__U5Htw","incomplete":"EntityList_incomplete__24NXY","title":"EntityList_title__Yr8+8"};